export const ACTION_SHOW_SNACKBAR = 'action_show_snackbar';
export const ACTION_HIDE_SNACKBAR = 'action_hide_snackbar';